import React from 'react';
import { features } from '../mock/mock';

const Marquee = () => {
  const line1 = [...features, ...features];
  const line2 = [...features.slice().reverse(), ...features.slice().reverse()];

  return (
    <section className="py-8 lg:py-12 border-y border-white/5 bg-white/[0.02] overflow-hidden">
      <div className="marquee-track-slow flex items-center gap-8 mb-4">
        {line1.map((f, i) => (
          <div key={i} className="flex items-center gap-8 whitespace-nowrap">
            <span className="text-3xl md:text-5xl font-bold text-white/90" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{f}</span>
            <span className="w-3 h-3 rounded-full bg-[#ff8247]" />
          </div>
        ))}
      </div>
      <div className="marquee-track-reverse flex items-center gap-8">
        {line2.map((f, i) => (
          <div key={i} className="flex items-center gap-8 whitespace-nowrap">
            <span className="text-3xl md:text-5xl font-bold gradient-text-warm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{f}</span>
            <span className="w-3 h-3 rounded-full bg-white/30" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
